import { html } from '../../mixins/katapult-element.js';
import { KatapultEditorFrame } from './katapult-editor-template.js';
import { ModelSharingLink } from '../sharing-link/model-sharing-link.js';

customElements.define(
  'katapult-cross-server-model-space-sharing',
  class extends KatapultEditorFrame {
    static get template() {
      return html`
        ${super.style}

        <katapult-firebase-worker path="[[modelSpaceDetails.path]]/sharing_links/model_sharing" data="{{sharingLinks}}">
        </katapult-firebase-worker>

        <paper-table outlined style="width: 700px;">
          <template is="dom-if" if="[[_outOfDate]]">
            <div style="padding: 0 24px;">
              <div
                style="display: flex; align-items: center; justify-content: center; padding: 16px; gap: 16px; color: var(--paper-red-500); border: 1px solid var(--paper-grey-200); background: var(--paper-grey-50); border-radius: 16px;"
              >
                <material-icon icon="warning"></material-icon>
                <div>Shared copies of this model have not been updated</div>
                <katapult-button red icon="sync" callback="_updateModels">Update Now</katapult-button>
              </div>
            </div>
          </template>
          <paper-row expand>
            <paper-cell icon>
              <material-icon icon="cloud_sync"></material-icon>
            </paper-cell>
            <paper-cell shrink>Sharing Links</paper-cell>
            <paper-cell>
              <paper-table style="flex-grow: 1;">
                <template is="dom-repeat" items="[[sharingLinksArray]]">
                  <paper-row expand>
                    <paper-cell>
                      <model-sharing-link
                        style="flex-grow: 1;"
                        link-id="[[item.$key]]"
                        sharing-link="[[item]]"
                        company-id="[[modelSpaceDetails.$key]]"
                      ></model-sharing-link>
                    </paper-cell>
                  </paper-row>
                </template>
                <paper-row expand>
                  <paper-cell justify-center>
                    <katapult-button color="var(--secondary-color)" icon="add_link" callback="generateSharingLink"
                      >Create Sharing Code</katapult-button
                    >
                  </paper-cell>
                </paper-row>
              </paper-table>
            </paper-cell>
          </paper-row>
        </paper-table>
      `;
    }

    static get properties() {
      return {
        sharingLinksArray: {
          type: Array,
          computed: '_computeSharingLinksArray(sharingLinks, serverTimeOffset)'
        },
        serverTimeOffset: {
          type: Number,
          value: 0
        }
      };
    }

    static get observers() {
      return ['_updateOutOfDate(sharingLinks)'];
    }

    ready() {
      super.ready();
      FirebaseWorker.ref('.info/serverTimeOffset')
        .once('value')
        .then((s) => (this.serverTimeOffset = s.val()));
    }

    _computeSharingLinksArray() {
      return Object.entries(this.sharingLinks ?? {})
        .map(([$key, x]) => ({ $key, ...x }))
        .filter((x) => {
          // Hide expired pending links.
          return x.pending == null || x.expires_at == null || x.expires_at > Date.now() + this.serverTimeOffset;
        });
    }

    async generateSharingLink(e) {
      const button = e.currentTarget;
      const metadata = {
        source_company_id: this.userGroup,
        source_company_name: this.userCompanyName
      };
      await ModelSharingLink.serverAction({
        action: 'create',
        linkType: 'model_sharing',
        companyId: this.modelSpaceDetails.$key,
        metadata
      });
      button.showSuccess();
    }

    _updateOutOfDate() {
      this._outOfDate = Object.values(this.sharingLinks ?? {}).some((x) => !x.pending && !x.metadata?.up_to_date);
    }

    async _updateModels(e) {
      const button = e.currentTarget;
      for (const linkId in this.sharingLinks) {
        if (!this.sharingLinks[linkId].pending) {
          await ModelSharingLink.updateSharedModel({ linkId, companyId: this.modelSpaceDetails.$key });
        }
      }
      button.showSuccess();
    }
  }
);
